const FEATURE_FLAG_ON_VALUE = 'on';

const FEATURE_FLAG_NAMES = {
    PROFILE_ADDRESS_AUTOCOMPLETE_FEATURE_FLAG: 'boysenberry-address-autocomplete-profile',
    DELIVERY_ADDRESS_AUTOCOMPLETE_FEATURE_FLAG: 'boysenberry-address-autocomplete-delivery',
    FOOD_PREFERENCES_FEATURE_FLAG: 'food_preferences',
    OPTIONAL_TIPS_COPY_TREATMENT: 'driver-tips-optional-copy',
    PRODUCT_PRICING_TREATMENT: 'pricing-title-restructure',
    UP_SELLS_CAROUSEL: 'upsells-carousel',
    UP_SELLS_CAROUSEL_PLP: 'upsells-carousel-plp',
    PLUS_MEMBERSHIP: 'membership',
    PLUS_MEMBERSHIP_SIGNUP: 'membership-signup',
    FRESHNESS_GUARANTEE: 'freshness-guarantee',
    MOBILE_PAYMENT_CTA: 'mobile-payment-cta',
};

export { FEATURE_FLAG_NAMES, FEATURE_FLAG_ON_VALUE };
